import { apiClient } from "./client";
import {
  AuthModel,
  LoginModel,
  RegisterModel,
  ForgotPasswordModel,
  ResetPasswordModel,
} from "@/types/auth";

export const authApi = {
  /**
   * Logs in a user.
   * @param data The user's credentials.
   * @returns An AuthModel containing the JWT token, expiration, roles, etc.
   */
  login: (data: LoginModel) => {
    return apiClient.post<AuthModel>("/Auth/login", data);
  },

  /**
   * Registers a new student.
   * @param data The user's registration information.
   * @returns An AuthModel containing the JWT token, expiration, roles, etc.
   */
  register: (data: RegisterModel) => {
    return apiClient.post<AuthModel>("/Auth/register", data);
  },

  /**
   * Registers a new admin.
   * @param data The user's registration information.
   * @returns An AuthModel containing the JWT token, expiration, roles, etc.
   */
  registerAdmin: (data: RegisterModel) => {
    return apiClient.post<AuthModel>("/Auth/register-admin", data);
  },

  /**
   * Initiates the password recovery flow.
   * @param data ForgotPasswordModel containing the user's email.
   * @returns An object containing the reset token.
   */
  forgotPassword: (data: ForgotPasswordModel) => {
    return apiClient.post<{ token: string }>("/Auth/forgot-password", data);
  },

  /**
   * Resets the password using the recovery token.
   * @param data ResetPasswordModel containing email, otpCode, and newPassword.
   * @returns Response message from backend.
   */
  resetPassword: (data: ResetPasswordModel) => {
    return apiClient.post<{ message: string }>("/Auth/reset-password", data);
  },

  /**
   * Changes the current user's password. Requires the correct current password.
   * @param data currentPassword and newPassword.
   * @returns Response message from backend.
   */
  changePassword: (data: { currentPassword: string; newPassword: string }) => {
    return apiClient.post<{ message: string }>('/Auth/change-password', data);
  },

  /**
   * Note: The backend AuthController doesn't currently expose a GET /Auth/me endpoint.
   * We decode the JWT token on the frontend to get user info if needed.
   */
};
